import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Card, CardContent, Grid2 } from '@mui/material'
import { getLogin } from 'utils/SettingUtils'
import moment from 'moment'
import { getVisitCheckBoxChange, getVisitDatePickerChange, getVisitSelectChange } from 'utils/VisitUtils'
import { getDate } from 'date-fns'
import { onChangeDate } from 'utils/FormUtils'
import DtoInstallation from 'installation/dto/installation/DtoInstallation'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import Checkbox from 'components/forms/Checkbox'
import { useSelector } from 'react-redux'
import { hasValue } from '../../../utils/NumberUtil'
import WifiIcon from '@mui/icons-material/Wifi'

const InstallationDataOriginPanel = ({
    readMode = false,
    station = {},
    onChange = () => { },
    onChangeVisit = () => { },
}) => {
    const {
        status,
        users,
    } = useSelector(store => ({
        status: store.QualityReducer.status,
        users: store.UserReducer.users,
    }))
    return (
        <Card>
            <CardContent>
                <Grid2 container columnSpacing={1}>
                    {hasValue(station.jobExecutionId) && (
                        <Grid2 container justifyContent='center' alignItems='center' spacing={1}>
                            <WifiIcon sx={{ fontSize: '40px' }} />
                            {i18n.automaticUpdate}
                        </Grid2>
                    )}
                    <Grid2 size={12}>
                        <Input
                            title={i18n.dataOrigin}
                            value={station.dataOrigin}
                            onChange={v => {
                                onChange({ dataOrigin: v })
                                onChangeVisit({ previousValue: station.dataOrigin, newValue: v, field: i18n.dataOrigin })
                            }}
                            readMode={readMode}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <Select
                            label={i18n.status}
                            value={station.status}
                            onChange={v => {
                                onChange({
                                    status: v,
                                    statusLogin: getLogin(),
                                    statusDate: moment().valueOf(),
                                })
                                onChangeVisit(getVisitSelectChange(status, 'code', i18n.status, station.status, v))
                                onChangeVisit({ previousValue: station.statusLogin, newValue: getLogin(), field: i18n.controlDoneBy })
                                onChangeVisit({ previousValue: station.statusDate, newValue: moment().valueOf(), field: i18n.controlDoneAt })
                            }}
                            options={status}
                            keyValue='code'
                            integerValue
                            readMode={readMode}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <Input
                            value={getDate(station.statusDate)}
                            title={i18n.controlDoneAt}
                            onChange={v => {
                                onChangeDate(v, v2 => onChange({ statusDate: v2 }))
                                onChangeVisit(getVisitDatePickerChange(i18n.controlDoneAt, station.statusDate, v))
                            }}
                            readMode={readMode}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <Select
                            label={i18n.controlDoneBy}
                            value={station.statusLogin}
                            keyValue='name'
                            onChange={v => {
                                onChange({ statusLogin: v })
                                onChangeVisit(getVisitSelectChange(users.map(u => ({ code: u.login, name: u.name || u.login })), 'name', i18n.controlDoneBy, station.statusLogin, v))
                            }}
                            options={users.map(u => ({ code: u.login, name: u.name || u.login }))} readMode={readMode}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <Input
                            value={getDate(station.endDate)}
                            title={i18n.deliberationDate}
                            onChange={v => {
                                onChangeDate(v, v2 => onChange({ endDate: v2 }))
                                onChangeVisit(getVisitDatePickerChange(i18n.deliberationDate, station.endDate, v))
                            }}
                            readMode={readMode}
                        />
                    </Grid2 >
                    <Grid2 size={12}>
                        <Input
                            value={station.closeComment}
                            title={i18n.become}
                            onChange={v => {
                                onChange({ closeComment: v })
                                onChangeVisit({ previousValue: station.closeComment, newValue: v, field: i18n.become })
                            }} readMode={readMode}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <Checkbox
                            label={i18n.confidential}
                            checked={station.confidential === '1'}
                            onChange={v => {
                                onChange({ confidential: v ? '1' : '0' })
                                onChangeVisit(getVisitCheckBoxChange(i18n.confidential, station.confidential === '1', v))
                            }}
                            disabled={readMode}
                        />
                    </Grid2 >
                </Grid2 >
            </CardContent>
        </Card>
    )
}

InstallationDataOriginPanel.propTypes = {
    readMode: PropTypes.string,
    station: PropTypes.instanceOf(DtoInstallation),
    onChange: PropTypes.func,
    onChangeVisit: PropTypes.func,
}

export default InstallationDataOriginPanel